export var FUND_DEFINITION_KEY = 'fundDefinition';
export var FUND_VARIATION_KEY = 'fundVariation';
export var FUND_SALE_KEY = 'fundSale';
export var FUND_DEFAULT_KEY = 'fundDefault';
export var FUND_CURRENCY_RISK_KEY = 'fundCurrencyRisk';
export var FUND_NET_ASSET_KEY = 'fundNetAssetValue';
